import { createContext, useContext, useState } from 'react';
import { toast } from 'sonner';

const ComparisonContext = createContext();

export const useComparison = () => {
  const context = useContext(ComparisonContext);
  if (!context) {
    throw new Error('useComparison must be used within ComparisonProvider');
  }
  return context;
};

export const ComparisonProvider = ({ children }) => {
  const [compareList, setCompareList] = useState([]);
  const [showComparison, setShowComparison] = useState(false);

  const addToCompare = (productId) => {
    if (compareList.includes(productId)) {
      toast.info('Product already in comparison');
      return;
    }
    
    if (compareList.length >= 4) {
      toast.error('You can only compare up to 4 products');
      return;
    }

    setCompareList([...compareList, productId]);
    toast.success('Added to comparison');
  };

  const removeFromCompare = (productId) => {
    setCompareList(compareList.filter(id => id !== productId));
    toast.success('Removed from comparison');
  };

  const clearCompare = () => {
    setCompareList([]);
    setShowComparison(false);
  };

  const toggleComparison = () => {
    if (compareList.length < 2) {
      toast.error('Add at least 2 products to compare');
      return;
    }
    setShowComparison(!showComparison);
  };

  return (
    <ComparisonContext.Provider
      value={{
        compareList,
        showComparison,
        addToCompare,
        removeFromCompare,
        clearCompare,
        toggleComparison,
        setShowComparison
      }}
    >
      {children}
    </ComparisonContext.Provider>
  );
};
